import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { LegalNotes } from "./LegalNotes";
import { Mail } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#121212] text-neutral-300 py-20 md:py-28 px-6 md:px-12"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-16">
      <div className="md:col-span-4 space-y-6">
        <Logo variant="light" size="md" />
        <p className="text-sm text-neutral-400 leading-relaxed max-w-xs">
          Finanzia il lusso. Prenota il futuro.
          <br />
          Club privato di co-finanziamento turistico.
        </p>
        <a
          href="mailto:info@suitecrowd.com"
          data-testid="footer-email"
          className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
        >
          <Mail size={13} /> info@suitecrowd.com
        </a>
        <nav className="pt-4 grid grid-cols-2 gap-y-3 max-w-xs">
          <Link
            to="/"
            data-testid="footer-link-home"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Home
          </Link>
          <Link
            to="/come-funziona"
            data-testid="footer-link-how"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Come Funziona
          </Link>
          <Link
            to="/manifesto"
            data-testid="footer-link-manifesto"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Manifesto
          </Link>
          <Link
            to="/faq"
            data-testid="footer-link-faq"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            FAQ
          </Link>
          <Link
            to="/hotel-pilota"
            data-testid="footer-link-pilot"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Hotel Pilota
          </Link>
          <Link
            to="/proponi"
            data-testid="footer-link-propose"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Proponi Hotel
          </Link>
          <Link
            to="/termini"
            data-testid="footer-link-terms"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Termini
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/admin-login"
            data-testid="footer-link-admin"
            className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
          >
            Admin
          </Link>
        </nav>
      </div>
      <div className="md:col-span-8">
        <LegalNotes />
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between gap-3 text-[11px] text-neutral-500 tracking-wider">
      <div>© {new Date().getFullYear()} SuiteCrowd — Tutti i diritti riservati.</div>
      <div>Escrow via Stripe · Trasparenza garantita</div>
    </div>
  </footer>
);
